import React from 'react';
import PropTypes from 'prop-types';
import styles from "./YellowErrorBlock.scss";

const YellowErrorBlock = ({error}) => {
	if (!error) {
		return null;
	}
	return (
	  <div className={`${styles.container}`} data-test="yellow-error-block">
		  <div className={styles.message}>
			  {error}
		  </div>
	  </div>
	);
};

YellowErrorBlock.propTypes = {
	error: PropTypes.string.isRequired
};

export default YellowErrorBlock;